import {itemWithoutDiscounts} from './itemWithoutDiscounts';

export const query = `query getRelatedProductsByAlgorithmWithoutDiscounts($productIds: [String!]!, $algorithm: Algorithm, $externalId: String!, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
  appSettings(externalId: $externalId) {
    widgetSettings
  }
  catalog {
    isCatalogV3
    relatedProducts(productIds: $productIds, algorithm: $algorithm) {
      ${itemWithoutDiscounts}
    }
  }
}
`;
